module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/payroll/payroll-sanction/payroll-sanction-form/payroll-sanction-form.component.css
// module id = ./src/app/hrms/payroll/payroll-sanction/payroll-sanction-form/payroll-sanction-form.component.css
// module chunks = main